<template>
  <div id="breadcrumb" v-dragscroll class="bread">
    <div v-for="(item, index) in breadList" :key="item.id" class="item">
      <a v-if="index !== breadList.length - 1" @click="() => onLast(item.id)">{{ item.name }}</a>
      <a v-else style="color: #43425d">{{ item.name }}</a>
      <svg-icon v-if="index !== breadList.length - 1" icon-class="arrow-r" class="icon" />
    </div>
  </div>
</template>

<script>

import { dragscroll } from 'vue-dragscroll';
export default {
  name: 'Bread',
  directives: {
    'dragscroll': dragscroll
  },
  props: ['breadList'],
  watch: {
    breadList(newVal) {
      const content = document.getElementById('breadcrumb');
      this.$nextTick(() => {
        content.scrollLeft = content.offsetWidth;
      });
    }
  },
  methods: {
    onLast(id) {
      this.$emit('onBread', id);
    }
  }
};
</script>

<style lang="less" scoped>
  .bread {
    display: flex;
    align-items: center;
    padding: 1em;
    margin-right: 1em;
    overflow-x: hidden;

    .item {
      white-space:nowrap;
      .icon {
        margin-left: 0.3em;
        margin-right: 0.3em;
        font-size: 0.8em;
      }

      a {
        color: #3b86ff;
      }
    }
  }
</style>
